'use strict';

const _=require('pulsar-utils/dist-es6/_');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');

const _FifteenMinutesInMillis=timespan.fromMinutes(15).totalMilliseconds();let

FatigueExtensions=class FatigueExtensions{
constructor(self){
this._self=self;
}

get fatigueAtTime(){
const fatigue=this._self;

if(fatigue.length===0){
return time=>void 0;
}

const fatigueStartTime=_.first(fatigue).time.getTime();
const fatigueEndTime=_.last(fatigue).time.getTime();

let fatigueIndex=0;

return time=>{
time=typeof time=='number'?time:time.getTime();

if(time<fatigueStartTime){
if(fatigueStartTime-time>=_FifteenMinutesInMillis){
return void 0;
}
fatigueIndex=0;
time=fatigueStartTime;
}else if(time>fatigueEndTime){
if(time-fatigueEndTime>=_FifteenMinutesInMillis){
return void 0;
}
fatigueIndex=fatigue.length-1;
time=fatigueEndTime;
}

if(time<fatigue[fatigueIndex].time.getTime()){
fatigueIndex=_.findLastIndex(fatigue,p=>p.time.getTime()<=time,fatigueIndex);

}

fatigueIndex=_.findIndex(fatigue,p=>p.time.getTime()>=time,fatigueIndex);

return fatigue[fatigueIndex].value;
};
}

get maxDuring(){

const fatigueAtTime=this.fatigueAtTime;

return timeInterval=>{
let now=timeInterval.start.getTime();
const end=timeInterval.end.getTime();

let max=-1;
while(now<=end){
const fatigue=fatigueAtTime(now);
if(fatigue!==void 0&&fatigue>max){
max=fatigue;
}
now+=_FifteenMinutesInMillis;
}
return max===-1?void 0:max;
};
}

peakConsistentWithFatigueApi(duties){
if(duties.length===0){
return;
}

const typeOrder={e:3,f:2,s:1};

const dutyPosts=TimeInterval.compress(duties).flatMap(duty=>[{type:'s',time:duty.start,duty},{type:'e',time:duty.end,duty}]);
const fatiguePosts=this._self.map(point=>({type:'f',time:point.time,point}));
const allPosts=_.sortBy(fatiguePosts.concat(dutyPosts),p=>p.time.getTime(),({type})=>typeOrder[type]);

let inDuty=!1;
let sawFatigueInDuty=!1;
let currentPeak=null;
let lastFatiguePostPassed=null;
let lastDutyPassed=null;

const makePoint=(time,original)=>_.defaults({time},original);

const trySetPeak=(fatiguePost,timeOverride)=>{
if(!fatiguePost){
return;
}

if(!currentPeak||fatiguePost.point.value>currentPeak.value){
fatiguePost.peaking=!0;
const{point}=fatiguePost;
currentPeak=timeOverride?makePoint(timeOverride,point):point;
}
};

for(const post of allPosts){
if(post.type==='f'){
if(inDuty){
sawFatigueInDuty=!0;
trySetPeak(post);
}else if(currentPeak&&lastFatiguePostPassed.peaking&&post.point.value>currentPeak.value){

currentPeak=makePoint(lastDutyPassed.end,currentPeak);
}
lastFatiguePostPassed=post;
}else if(post.type==='s'){
sawFatigueInDuty=!1;
inDuty=!0;
}else if(post.type==='e'){
inDuty=!1;
if(!sawFatigueInDuty&&lastFatiguePostPassed){
trySetPeak(lastFatiguePostPassed,post.duty.start);
}
lastDutyPassed=post.duty;
}
}

return currentPeak;
}










static tagIfForecasted(point,now){
if(point&&point.time.getTime()>now.getTime()){
point.forecasted=!0;
}
}

static extend(self){
return new FatigueExtensions(self);
}};


module.exports=FatigueExtensions.extend;
module.exports.tagIfForecasted=FatigueExtensions.tagIfForecasted;
//# sourceMappingURL=fatigueExtensions.js.map
